import { RootState } from '../../store';

export const getSettlementsSelector = (state: RootState) => state?.settlementReducer?.settlements;
